// eslint-disable-next-line import/prefer-default-export
export const rehydratedSelector = state => state.getIn(['app', 'rehydrated']);
